/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feminized_SeedsInputs */

const en_feminized_seeds = /** @type {(inputs: Feminized_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feminized Seeds`)
};

const th_feminized_seeds = /** @type {(inputs: Feminized_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมล็ดพันธุ์เพศเมีย`)
};

const ja_feminized_seeds = /** @type {(inputs: Feminized_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フェミナイズドシード`)
};

const fr_feminized_seeds = /** @type {(inputs: Feminized_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graines féminisées`)
};

const es_feminized_seeds = /** @type {(inputs: Feminized_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semillas feminizadas`)
};

const ru_feminized_seeds = /** @type {(inputs: Feminized_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Феминизированные семена`)
};

const zh_feminized_seeds = /** @type {(inputs: Feminized_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`女性化种子`)
};

const vi_feminized_seeds = /** @type {(inputs: Feminized_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hạt giống nữ hóa`)
};

/**
* | output |
* | --- |
* | "Feminized Seeds" |
*
* @param {Feminized_SeedsInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const feminized_seeds = /** @type {((inputs?: Feminized_SeedsInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feminized_SeedsInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_feminized_seeds(inputs)
	if (locale === "ja") return ja_feminized_seeds(inputs)
	if (locale === "fr") return fr_feminized_seeds(inputs)
	if (locale === "es") return es_feminized_seeds(inputs)
	if (locale === "ru") return ru_feminized_seeds(inputs)
	if (locale === "zh") return zh_feminized_seeds(inputs)
	if (locale === "vi") return vi_feminized_seeds(inputs)
	return en_feminized_seeds(inputs)
});